export const categoryList = [
  "AI Agents & Automation",
  "Generative AI & Content Creation",
  "Natural Language Processing",
  "Computer Vision",
  "LLMOps & Model Management",
  "AI Infrastructure & GPU",
  "Predictive Analytics",
  "Business Intelligence & Data Visualization",
  "Chatbots & Virtual Assistants",
  "Recommendation Systems",
  "Fraud Detection & Security",
  "Healthcare AI",
  "Financial AI",
  "Marketing & Sales AI",
  "HR & Talent Management",
  "Edge AI & IoT",
  "Data Processing & ETL",
  "AI Development Tools",
  "Sentiment Analysis & Text Mining",
  "Other",
];
